import React, { useEffect, useState } from "react";
import { ACC_STATUS, PRO_STATUS } from "../../services/constant";
import { MenuItem } from "@mui/material";
import {
  account_profile_status,
  createAdmin,
  deleteAdmin,
  getAllAdmin,
  updateAdmin,
} from "../../api/fetch";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert";
import * as Yup from "yup";
import { useQuery } from "@tanstack/react-query";

const AdminEditSchema = Yup.object().shape({
  fullName: Yup.string().required("Full Name is required"),
  emailAddress: Yup.string()
    .email("Invalid email address")
    .required("Email Address is required"),
  userName: Yup.string().required("User Name is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters long")
    .required("Password is required"),
  mobile_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile Number must be 10 digits")
    .required("Mobile Number is required"),
  accountStatus: Yup.string().required("Account Status is required"),
  profileStatus: Yup.string().required("Profile Status is required"),
});

function Provider() {
  const [fullName, setFullname] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [mobile_number, setMobile_Number] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const [profileStatus, setProfileStatus] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const [allData, setAllData] = useState([]);
  const [adm_id, setAdm_id] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [errors, setErrors] = useState({});
  const [openEdit, setOpenEdit] = useState(false);

  const handlerefresh = () => {
    setRefresh(!refresh);
  };

  const navigate = useNavigate();
  const loc = useLocation().state;

  //   const { data, error, isLoading } = useQuery({
  //     queryKey: ["role_id", loc?.role_id],
  //     queryFn: () => getAllAdmin({ role_id: loc?.role_id }),
  //     retry: 1, // Number of retries on failure
  //     staleTime: 60000, // Time in milliseconds to consider data fresh
  //   });

  //Validate Form One -------->>>>>>
  const validateForm = async () => {
    try {
      await AdminEditSchema.validate(
        {
          fullName,
          emailAddress,
          mobile_number,
          userName,
          password,
          accountStatus,
          profileStatus,
        },
        { abortEarly: false }
      );
      return null; // No errors
    } catch (err) {
      // Extract errors
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      return newErrors;
    }
  };

  useEffect(() => {
    fetchAllAdmin();
  }, [loc, refresh]);

  const fetchAllAdmin = async () => {
    var body = {
      role_id: loc?.role_id,
    };
    try {
      setIsLoading(true);
      const res = await getAllAdmin(body);
      setAllData(res?.data);
      setIsLoading(false);
    } catch (error) {
      console.log("Eroro ::", error);
    }
  };

  console.log("LOC ::", loc);

  // Fill Account Status -------------->
  const fillAcconutStatus = () => {
    return ACC_STATUS?.map((item) => {
      return (
        <MenuItem sx={{ fontFamily: "Poppins" }} value={item?.id}>
          {item?.name}
        </MenuItem>
      );
    });
  };

  // Fill Profile Status -------------->
  const fillProfileStatus = () => {
    return PRO_STATUS?.map((item) => {
      return (
        <MenuItem sx={{ fontFamily: "Poppins" }} value={item?.id}>
          {item?.name}
        </MenuItem>
      );
    });
  };

  // Handle Select Account Status
  const handleAccount = (event) => {
    setAccountStatus(event.target.value);
  };

  // Handle Select Profile Status
  const handleProfile = (event) => {
    setProfileStatus(event.target.value);
  };

  /// Manage Upload Image ------>
  const handleImage = (event) => {
    setImage(event.target.files[0]);
    setPreview(URL.createObjectURL(event.target.files[0]));
  };

  //Handle Submit  ----->>>
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formErrors = await validateForm();
    if (formErrors) {
      setErrors(formErrors);
    } else {
      setErrors({});
    }

    var formData = new FormData();
    formData.append("name", fullName);
    formData.append("email", emailAddress);
    formData.append("mobile_number", mobile_number);
    formData.append("username", userName);
    formData.append("password", password);
    formData.append("account_status", accountStatus);
    formData.append("profile_status", profileStatus);
    formData.append("image", image);
    formData.append("role", loc?.role);
    formData.append("role_id", loc?.role_id);
    formData.append("admin_id", adm_id);

    if (openEdit) {
      const res = await updateAdmin(formData);

      if (res?.status) {
        Swal({
          title: "Success",
          text: res?.msg,
          timer: 1000,
        });
        fetchAllAdmin();
        close();
      } else {
        Swal(
          {
            title: "Oopps!",
            text: res?.msg,
            timer: 3000,
          }
          //   Swal("Nice!", res?.data?.msg, "success")
        );
      }
    } else {
      const res = await createAdmin(formData);

      if (res?.status) {
        Swal({
          title: "Success",
          text: res?.msg,
          timer: 1000,
        });
        navigate("/Dashboard/Admin", {
          state: { role: "Manager", role_id: 3 },
        });
      } else {
        Swal(
          {
            title: "Oopps!",
            text: res?.msg,
            timer: 3000,
          }
          //   Swal("Nice!", res?.data?.msg, "success")
        );
      }
    }
  };

  //Handle Reset  ----->>>
  const handleReset = async (event) => {};

  const handleActive = async (rowData) => {
    console.log("HANDNKEE ACTVEE ::", rowData);

    const body = {
      id: rowData?.id,
      role_id: rowData?.role_id,
      astatus: true,
    };
    console.log("BODYDY ACTVEE ::", body);

    try {
      const res = await account_profile_status(body);
      console.log("RESSSS ::", res);
      handlerefresh();
    } catch (error) {
      console.log("Eroor ::", error);
    }
  };

  const handleApprove = async (rowData) => {
    console.log("HANDNKEE ACTVEE ::", rowData);
    const body = {
      id: rowData?.id,
      role_id: rowData?.role_id,
      pstatus: true,
    };
    console.log("APprovee BODYY ::", body);

    try {
      const res = await account_profile_status(body);
      console.log("RESSS APPROVEE ::", res);
      handlerefresh();
    } catch (error) {
      console.log("Error :", error);
    }
  };

  const handleEdit = async (rowData) => {
    console.log("EDITT ROWW ::0", rowData);
    open();
    // // navigate("/Dashboard/addAdmin", { state: { Title: "Edit" } });
    setFullname(rowData?.name);
    setMobile_Number(rowData?.mobile_number);
    setUserName(rowData?.username);
    setEmailAddress(rowData?.email);
    setPassword(rowData?.password);
    setPreview(rowData?.image);
    setAdm_id(rowData?.id);
    setAccountStatus(rowData?.account_status);
    setProfileStatus(rowData?.profile_status);
  };
  const open = () => {
    setOpenEdit(true);
  };

  const close = () => {
    setOpenEdit(false);
  };

  const handleDelete = async (rowData) => {
    console.log("DELETEEE ::", rowData);

    var id = rowData?.id;

    Swal({
      title: "Are you sure?",
      text: "Delete this Admin Record!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        const res = await deleteAdmin(id);
        Swal({
          title: "Success",
          text: res?.msg,
          timer: 1000,
        });
        fetchAllAdmin();
      } else {
        Swal("Cancelled", "Your Admin Record is safe :)", "error");
      }
    });
    // const res = await deleteAdmin(formData);

    // if (res?.status) {
    //   Swal({
    //     title: "Success",
    //     text: res?.msg,
    //     timer: 1000,
    //   });
    //   fetchAllAdmin();
    // } else {
    //   Swal(
    //     {
    //       title: "Oopps!",
    //       text: res?.msg,
    //       timer: 3000,
    //     }
    //     //   Swal("Nice!", res?.data?.msg, "success")
    //   );
    // }
  };

  return {
    fullName,
    setFullname,
    emailAddress,
    setEmailAddress,
    mobile_number,
    setMobile_Number,
    password,
    setPassword,
    accountStatus,
    setAccountStatus,
    profileStatus,
    setProfileStatus,
    image,
    setImage,
    preview,
    setPreview,
    userName,
    setUserName,
    fillAcconutStatus,
    fillProfileStatus,
    handleAccount,
    handleProfile,
    handleImage,
    handleSubmit,
    handleReset,
    allData,
    isLoading,
    handleActive,
    handleApprove,
    handleEdit,
    handleDelete,
    errors,
    openEdit,
    setOpenEdit,
    setIsLoading,
    // data,
    // isLoading,
  };
}

export default Provider;
